"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionLogAction = exports.ActionLogCategory = exports.ActionLogLevel = exports.WarehouseStatus = exports.Unit = exports.MenuItemStatus = exports.MenuItemType = exports.PaymentMethod = exports.CategoryStatus = exports.MenuItemCategory = exports.TransactionType = exports.OrderStatus = void 0;
// Enums
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["PENDING"] = "pending";
    OrderStatus["COMPLETED"] = "completed";
    OrderStatus["CANCELLED"] = "cancelled";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType["IMPORT"] = "import";
    TransactionType["CONSUMPTION"] = "consumption";
})(TransactionType || (exports.TransactionType = TransactionType = {}));
var MenuItemCategory;
(function (MenuItemCategory) {
    MenuItemCategory["COFFEE"] = "coffee";
    MenuItemCategory["TEA"] = "tea";
    MenuItemCategory["JUICE"] = "juice";
    MenuItemCategory["SMOOTHIE"] = "smoothie";
    MenuItemCategory["BAKERY"] = "bakery";
    MenuItemCategory["TOBACCO"] = "tobacco";
    MenuItemCategory["OTHER"] = "other";
})(MenuItemCategory || (exports.MenuItemCategory = MenuItemCategory = {}));
var CategoryStatus;
(function (CategoryStatus) {
    CategoryStatus["ACTIVE"] = "active";
    CategoryStatus["INACTIVE"] = "inactive";
})(CategoryStatus || (exports.CategoryStatus = CategoryStatus = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CASH"] = "cash";
    PaymentMethod["CARD"] = "card";
    PaymentMethod["TRANSFER"] = "transfer";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
var MenuItemType;
(function (MenuItemType) {
    MenuItemType["MANUFACTURED"] = "manufactured";
    MenuItemType["DIRECT"] = "direct";
})(MenuItemType || (exports.MenuItemType = MenuItemType = {}));
var MenuItemStatus;
(function (MenuItemStatus) {
    MenuItemStatus["ACTIVE"] = "active";
    MenuItemStatus["INACTIVE"] = "inactive";
})(MenuItemStatus || (exports.MenuItemStatus = MenuItemStatus = {}));
var Unit;
(function (Unit) {
    Unit["GRAM"] = "g";
    Unit["KILOGRAM"] = "kg";
    Unit["MILLILITER"] = "ml";
    Unit["LITER"] = "l";
    Unit["BOTTLE"] = "bottle";
    Unit["CAN"] = "can";
    Unit["PACKED"] = "packed";
})(Unit || (exports.Unit = Unit = {}));
var WarehouseStatus;
(function (WarehouseStatus) {
    WarehouseStatus["ACTIVE"] = "active";
    WarehouseStatus["INACTIVE"] = "inactive";
})(WarehouseStatus || (exports.WarehouseStatus = WarehouseStatus = {}));
// User Action Log Types
var ActionLogLevel;
(function (ActionLogLevel) {
    ActionLogLevel["LOW"] = "low";
    ActionLogLevel["MEDIUM"] = "medium";
    ActionLogLevel["HIGH"] = "high";
    ActionLogLevel["CRITICAL"] = "critical";
})(ActionLogLevel || (exports.ActionLogLevel = ActionLogLevel = {}));
var ActionLogCategory;
(function (ActionLogCategory) {
    ActionLogCategory["AUTH"] = "auth";
    ActionLogCategory["ORDER"] = "order";
    ActionLogCategory["CUSTOMER"] = "customer";
    ActionLogCategory["INVENTORY"] = "inventory";
    ActionLogCategory["MENU"] = "menu";
    ActionLogCategory["SYSTEM"] = "system";
    ActionLogCategory["FINANCIAL"] = "financial";
    ActionLogCategory["USER_MANAGEMENT"] = "user_management";
    ActionLogCategory["DATA_EXPORT"] = "data_export";
    ActionLogCategory["BULK_OPERATIONS"] = "bulk_operations";
})(ActionLogCategory || (exports.ActionLogCategory = ActionLogCategory = {}));
var ActionLogAction;
(function (ActionLogAction) {
    ActionLogAction["CREATE"] = "create";
    ActionLogAction["UPDATE"] = "update";
    ActionLogAction["DELETE"] = "delete";
    ActionLogAction["VIEW"] = "view";
    ActionLogAction["LOGIN"] = "login";
    ActionLogAction["LOGOUT"] = "logout";
    ActionLogAction["EXPORT"] = "export";
    ActionLogAction["PRINT"] = "print";
    ActionLogAction["BULK_CREATE"] = "bulk_create";
    ActionLogAction["BULK_UPDATE"] = "bulk_update";
    ActionLogAction["BULK_DELETE"] = "bulk_delete";
    ActionLogAction["RESTORE"] = "restore";
    ActionLogAction["MARK_PAID"] = "mark_paid";
    ActionLogAction["MARK_UNPAID"] = "mark_unpaid";
    ActionLogAction["SEARCH"] = "search";
})(ActionLogAction || (exports.ActionLogAction = ActionLogAction = {}));
